import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, Injector, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmEventType } from 'primeng/api';
import { MenuItem } from 'primeng/api/menuitem';
import { finalize } from 'rxjs/operators';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { UserPreferenceConstants } from 'src/app/core/constants/user-preference-constants.constant';
import { UserType } from 'src/app/core/enums/user-type.enum';
import { SortOrder } from 'src/app/core/interface/sort-order';
import { LaasOption } from 'src/app/core/models/laas-option';
import { PageInfo } from 'src/app/core/models/page-info';
import { CopyBillBookingRequest } from 'src/app/core/models/transport-operation/copy-bill-booking-request';
import { DownloadMergeFileRequset } from 'src/app/core/models/transport-operation/download-merge-file-request';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { FacilityService } from 'src/app/core/services/facility.service';
import { ShippingDocumentService } from 'src/app/core/services/shipping-document.service';
import { deepCopy, getDataScopeByPermission, getFacilityByPermission, getRoleScopeColumnMappings, isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { downloadExpressInvoiceRequest } from 'src/app/features/transport-operation/pages/booking-search/interface/downloadExpressInvoiceRequest';
import { BookingService } from 'src/app/features/transport-operation/services/booking.service';
import { ContainerService } from 'src/app/features/transport-operation/services/container-service.service';
import { TmsService } from 'src/app/features/transport-operation/services/tms.service';
import { CalendarComponent } from 'src/app/shared/components/calendar/calendar.component';
import { DataTableComponent } from 'src/app/shared/components/data-table/data-table.component';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { AddressMaintainanceService } from '../../service/address-maintainance.service';
import dateToString from 'src/app/shared/devtools/detector/sub-detector/date-to-string';

@Component({
  selector: 'laas-create-container',
  templateUrl: './create-container.component.html',
  styleUrls: ['./create-container.component.scss'],
})
export class CreateContainerComponent extends SessionBaseComponent implements OnInit {

  readonly preferenceKey: string;
  readonly preferenceKey2: string;
  readonly permissionCode: PermissionConstants = PermissionConstants.ViewQueryBookingForShipping;
  readonly permissionCodeForChangeBookingDetailStatus: PermissionConstants = PermissionConstants.ChangeBookingDetailStatus;
  readonly defaultCreateParams: any;
  readonly permissionCodeForChangePickStatus: PermissionConstants = PermissionConstants.BtnChangePickStatus;
  readonly csmCodeContainerCNFacility: string = 'ContainerCNFacility';
  @ViewChild('assignDate') assignDate!: CalendarComponent;
  @ViewChild('createDt') createDt!: CalendarComponent;

  bookingNo: string;

  searchParams: any;
  isLoading: boolean;
  isFormOpen:boolean = true;
  isCNFacility: boolean = false;

  facilityCode: string = this.laasSetting.facility;
  mValue: string="";
  trPaymentBy: any;
  facilityCodeChoosed:boolean=false;
  facilityOptions: any[] = [];
  bookingForwarderList: any[];
  deliveryCategoryList: any[];

  mvalueOptions: any[] = [];

  carSeqListSCDG: any[] = [];

  carSeqListLK: any[] = [];
  carTypeOptions: any[]= [];


  bookingTypeList: any[];
  bookingStatusOptions: any[];
  chargeStatusList: any[];
  shipTermOptions: LaasOption[];
  toCountryOptions: any[];
  toCityOptions: any[];
  assignmentDistrictIdOptions: any[];


  awbAddressOptions: any[];
  DOStatusOptions: any[];
  consigneeKeyOption: any[]=[];

  isSearchFormOpen: boolean;
  submitted: boolean = false;



  bookingDetails: any[];

  isShowErrorTmsModal: boolean;
  importedDOs: any[];

  importDocData: any[];
  isShowBillingPreviewCalculateViewerModal: boolean;
  isShowBookingDetailPickUpChangeModel: boolean;

  rowData: any;

  createForm: FormGroup;
  itemMenus: MenuItem[];
  mainItemMenus: MenuItem[];

  // file Management
  showDoFile: boolean;
  showDoPodFile: boolean;
  bookingNoFile: string;
  bookingInfo: any;
  bookingNoPreviewCalculate: string;
  showRedeliveryBooking: boolean;


  containerCode: string = '';
  isShowContainerCodeList: boolean = false;
  createCarType: any;
  licensePlateNo: string = '';


  selectedDORows: any[];

  tmsData: any;
  errorTmsBookingNo: string = '';

  billCorpOptions: any[];
  isPickupFlagList: any[];

  forwarderCodeOptions: LaasOption[] = [];

  redeliveryBookingCount: number;

  downloadMergeFileParams!: DownloadMergeFileRequset;
  @ViewChild(DataTableComponent) table!: DataTableComponent;

  rowRedeliveryCount: number | null;

  pageInfo: PageInfo = {
    pageSize: 5,
    pageIndex: 0,
    totalRecords: 0,
    totalPages: 0,
  };

  sortOrder: SortOrder = {
    property: "bookingNo",
    direction: -1
  };

  constructor(
    injector: Injector,
    private bookingService: BookingService,
    private commonDataService: CommonDataService,
    private facilityService: FacilityService,
    private dropdownOptionService: DropdownOptionsService,
    private formBuilder: FormBuilder,
    private containerService: ContainerService,
    private addressMaintainanceService: AddressMaintainanceService,
    private cdr: ChangeDetectorRef
  ) {
    super(injector);
    this.preferenceKey = UserPreferenceConstants.BookingSearchForShipping;
    this.preferenceKey2 = UserPreferenceConstants.BookingSearchForShippingDetail;

    this.createForm = this.formBuilder.group({
      facility: null,
      forwarder: null,
      deliveryCategory: [null, Validators.required],
      carSeqNo: [null, Validators.required],
      departureDay: [null, Validators.required],
      trPaymentBy: null,
      createCarType:  [null],
      licensePlateNo: null,
      isMValue: null,
      pickupLocationCode: null,
      consigneeKey: null,
    });

    this.isLoading = false;
    this.bookingStatusOptions = [];
    this.DOStatusOptions = [];
    this.bookingForwarderList = [];
    this.deliveryCategoryList = [];
    this.bookingTypeList = [];

    this.chargeStatusList = [];
    this.shipTermOptions = [];
    this.toCountryOptions = [];
    this.toCityOptions = [];
    this.assignmentDistrictIdOptions = [];
    this.awbAddressOptions = [];

    this.isSearchFormOpen = true;
    this.isShowErrorTmsModal = false;
    this.isShowBillingPreviewCalculateViewerModal = false;
    this.isShowBookingDetailPickUpChangeModel = false;
    this.importedDOs = [];
    this.bookingNo = '';
    this.bookingDetails = [];
    this.importDocData = [];
    // translate
    this.mainItemMenus = [];
    this.itemMenus = [];
    this.billCorpOptions = [];

    this.showDoFile = false;
    this.showDoPodFile = false;
    this.bookingNoFile = '';

    this.selectedDORows = [];

    this.selectedDORows = [];
    this.tmsData = [];

    // file management
    this.showDoFile = false;
    this.showDoPodFile = false;
    this.bookingNoFile = '';
    this.bookingNoPreviewCalculate = '';

    this.isPickupFlagList = [
      { value: 0, label: '全揀貨' },
      { value: 1, label: '含不揀貨' }
    ];
    this.showRedeliveryBooking = false;
    this.redeliveryBookingCount = 0;
    this.rowRedeliveryCount = 0;
    this.commonDataService.searchCsmDetailSetting(this.csmCodeContainerCNFacility).subscribe({
      next: (result) => {
        if(result == null || result.length == 0){
          return;
        }
        if(result.flatMap(x => x.setupValue).includes(this.facilityCode)){
          this.isCNFacility = true;
        }
      }
    });
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    const routeData = this.routeStateService.getCurrent()?.data;
    if (!isNullOrEmpty(routeData)) {
      this.searchParams.bookingNoList = routeData.bookingNoList;
      if (routeData.errMsgs != null && routeData.errMsgs.length > 0) {
        const msgs = routeData.errMsgs.reduce(
          (str: string, msg: string, idx: number) => {
            str += `${idx + 1}. ${msg}\n`;
            return str;
          }, '');
        this.toastService.error(msgs);
      }
    }

    this.dropdownOptionService.getFacilityOptions().subscribe({
      next: (options: any[]) => {
        this.facilityOptions = options.map(x => ({
          label: x.optionDesc,
          value: x.optionCode
        }));
      }
    });

    this.addressMaintainanceService.getCustomerOptions().subscribe({
      next: (result) => {
        this.consigneeKeyOption = [...result].map((x: any) => {
          return {
            label: `${x.customerCode} - ${x.customerName}`,
            value: x.customerCode,
          };
        });
      },
    });

    this.dropdownOptionService.getForwarderOptions().subscribe({
      next: (result) => {
        this.bookingForwarderList = result;
      }
    });


    this.dropdownOptionService.getDeliveryTypeOptions(false).subscribe({
      next: (options: any[]) => {
        this.deliveryCategoryList = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });

    this.dropdownOptionService.getPickupLocationOptions(this.facilityCode || 'SCDG').subscribe({
      next: (options: any[]) => {
        this.awbAddressOptions = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });

    this.translateService.get('Common.Message.ChooseOption')
    .subscribe({
      next: str => {
        this.mvalueOptions = [
          {
            label: '主倉 - main',
            value: 'main',
          },
          {
            label: '中轉倉 - transfer',
            value: 'transfer',
          },
        ];

        this.carSeqListSCDG = [
          {
            label: 'AM',
            value: 'AM'
          }, {
            label: 'PM',
            value: 'PM'
          }
        ];

        this.carSeqListLK = [
          {
            label: '0900',
            value: '0900'
          }, {
            label: '1600',
            value: '1600'
          }
        ];
      }
    });



    this.commonDataService
      .getCodeConverter(
        this.laasSetting.language,
        'DropdownList',
        'BookingQueryChargesStatus'
      )
      .subscribe({
        next: (options: any[]) => {
          this.chargeStatusList = options.map((x) => ({
            label: x.codeKey + '-' + x.codeDesc,
            value: x.codeKey,
          }));
        },
      });
    // permission Codes
    let userPermissionCodes = (
      Object.values(this.userProfile.roles).reduce(
        (c: any, i: any) => c.concat(i.permissions),
        []
      ) as any
    ).map((x: any) => {
      return x.permissionCode;
    });

    // rbac to maintain this page
    let canInPage = this.permissionCodes.includes(this.permissionCode);
    if (!canInPage) {
      // go unAuthorize
      this.routeStateService.navigateTo('/Error/unAuthorize');
    }


    this.dropdownOptionService.getForwarderOptions().subscribe({
      next: (result: any[]) => {
        this.forwarderCodeOptions = result.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      }
    });

    this.containerService.getTrDefaultPaymentBy(this.facilityCode).subscribe({
      next: (result) => {
        if(result != null){
          this.trPaymentBy = result.optionCode;
          console.log(" this.forwarderCode:",  this.trPaymentBy);
          this.cdr.detectChanges();
        }
      }
    });

    this.containerService.getCarType(this.laasSetting.facility).subscribe({
      next: (result) => {
        this.carTypeOptions = [...result].map((x: any) => {
          return {
            label: `${x.carType} - ${x.carCnDesc} (CBM: ${x.limitCbm})`,
            value: x.carType
          };
        });
      },
    });


  }

  dateOnChange(date: any, type: string) {
    switch (type) {
      case "departureDay":
      this.createForm.controls.departureDay.setValue(date.date);
        break;
    }
  }


  createBtnClick() {
    console.log("createForm:", this.createForm.value);
    this.isLoading = true;

    if (this.createForm.invalid) {
      this.submitted = true;
      this.toastService.warn(this.translateService.instant('Common.Toast.CheckRequiredFieldsOrFieldsFormat'));
      return;
    }

    if ((this.facilityCode === 'SCDG') && (this.mValue === 'main')) {
      if (isNullOrEmpty(this.createForm.controls.forwarder.value) || isNullOrEmpty(this.createForm.controls.pickupLocationCode.value)) {
        this.toastService.warn(this.translateService.instant('Common.Toast.CheckRequiredFieldsOrFieldsFormat'));
        return;
      }
    }
    const req = {
      // 共用欄位
      facility: this.facilityCode,
      containerType: this.createForm.controls.carSeqNo.value,
      departureDay: this.createForm.controls.departureDay.value,
      trPaymentBy : this.trPaymentBy,
      createCarType : this.createForm.controls.createCarType.value ?? '',
      licensePlateNo : this.createForm.controls.licensePlateNo.value,
      createUser: this.userService.userInfo.userName,

      // SCDG 專用欄位
      pickUpType: this.mValue,
      deliveryCategory: this.createForm.controls.deliveryCategory.value,
      pickupLocationCode: this.createForm.controls.pickupLocationCode.value,
      forwarder: this.createForm.controls.forwarder.value,
      consigneeKey: this.createForm.controls.consigneeKey.value,
    }

    console.log("createBtnClick req:", req);

    this.containerService.createContainerMA(req)
    .subscribe({
      next: (results: string) => {
        this.containerCode = results;
        this.isShowContainerCodeList = true;
        this.isLoading = false;
      },
      error: (err) => {
        this.isLoading = false;
        this.toastErrorMessage(err.error);
      },
      complete:()=>{
        this.isLoading = false;
      }
    });

  }




}
